<template>
  <tr>
    <td>{{user.displayName}}</td>
    <td>{{user.email}}</td>
    <td>
      <ToggleSwitch :disabled="isSelf" :active="isAdmin" v-on:toggleOn="makeAdmin()" v-on:toggleOff="removeAdmin()" />
    </td>
    <td>
      <DropDown v-if="!isAdmin" :options="availableProjects" :darkMode="true" :placeholder="'Add project to user'" v-on:changeEvent="addProjectToUser($event,user.uid)"/>
    </td>
    <td>
      <div class="projectTagWrapper"><SmallTagGroup :tags="visibleProjects" v-on:closeButton="removeProjectFromUser($event,user.uid)" :readOnly="isAdmin"/></div>
    </td>
  </tr>
</template>

<script>
import ToggleSwitch from '../components/ui/ToggleSwitch.vue'
import DropDown from '../components/ui/DropDown.vue'
import SmallTagGroup from '../components/ui/SmallTagGroup.vue'

export default {
  name: 'AdminUserRow',
  props: {
    user: Object
  },
  components: {
    ToggleSwitch,
    DropDown,
    SmallTagGroup
  },
  computed: {
    isAdmin () {
      if (this.user.customClaims) {
        if (this.user.customClaims.admin) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isSelf () {
      if (this.user.uid == "3MB6PjRrdFaJAKIZIGGx2JKhJ533") {
        return true
      } else {
        return false
      }
    },
    availableProjects() {
      var allClients = this.$store.getters.clientArray
      var filteredClients = allClients.filter((client)=>{
        return !this.visibleProjects.includes(client)
      })
      return filteredClients
    },
    visibleProjects() {
      var clientList = []
      var allClients = this.$store.getters.clientArray
      if (this.user.customClaims) {
        if (this.user.customClaims.admin) {
          clientList = allClients
        } else {
          if (this.user.customClaims.projects) {
            this.user.customClaims.projects.forEach((clientKey) => {
              var matchingClients = allClients.filter(client => client.id === clientKey);
              if (matchingClients.length > 0) {
                clientList.push(matchingClients[0])
              } else {
                clientList.push({
                  name: clientKey,
                  id: clientKey
                })
              }
            })
          }
        }
      }
      return clientList
    }
  },
  methods: {
    makeAdmin(){
      this.$store.dispatch('makeAdmin',this.user.uid)
    },
    removeAdmin(){
      this.$store.dispatch('removeAdmin',this.user.uid)
    },
    addProjectToUser(projectID, userID){
      this.$store.dispatch('addProjectToUser',{userid: userID, projectid: projectID})
    },
    removeProjectFromUser(projectID, userID){
      this.$store.dispatch('removeProjectFromUser',{userid: userID, projectid: projectID})
    }
  }
}
</script>

<style>
  .projectTagWrapper {
    max-width: 400px;
  }
</style>
